import React from 'react';
import { Grid, Panel } from 'react-bootstrap';
import { Field, reduxForm } from "redux-form";
import { UnstiledDropdownListField } from '../../common/Inputs';
import { factories, acceptPoints } from '../../../constants/dcDepartmentTypes';
import { getSettings } from '../../../actions/settings';
import { connect } from 'react-redux';
import { departments as depType, agents as agentType } from '../../../constants/settingTypes';
import { getFormValues } from "redux-form";


let DcDepartmentsFilter = class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedAgent: this.props.initialValues.agent,
            selectedType: this.props.initialValues.departmentType
        };

        this.departmentFilter = this.departmentFilter.bind(this);
    }

    departmentFilter(departments, values) {
        const agent = values.agent != null ? values.agent.Id != null ? values.agent.Id : values.agent : undefined;
        const type = values.departmentType != null ? values.departmentType.Id != null ? values.departmentType.Id : values.departmentType : undefined;
        const { dcTypes } = this.props;

        var filtred = departments.filter(d => dcTypes.map(t => t.Id).includes(d.Type));
        if (agent == null && type == null)
            return filtred;

        filtred = agent != null ? filtred.filter(d => d.AgentId == agent) : filtred;
        filtred = type != null ? filtred.filter(d => d.Type == type) : filtred;
        return filtred;
    };

    componentDidMount() {
        this.props.getSettings(depType);
        this.props.getSettings(agentType);
    }

    render() {
        const agents = this.props.agents.data ? this.props.agents.data : [];
        const departments = this.props.departments.data ? this.props.departments.data : [];

        const renderSelectedDepartmentType = ({ item }) => {
            return commonSelectedValueRender(item, this.props.dcTypes, 'Name');
        };
        const renderSelectedDepartment = ({ item }) => {
            return commonSelectedValueRender(item, departments, 'FullName');
        };
        const renderSelectedAgent = ({ item }) => {
            return commonSelectedValueRender(item, agents, 'Name');
        };
        const commonSelectedValueRender = (item, collection, valueField) => {
            const id = item && item.Id != null ? item.Id : item == '' ? undefined : item;
            const valueFromCollection = collection.find(d => d.Id == id);
            const value = valueFromCollection ? valueFromCollection[valueField] : undefined;
            return (<span>{value}</span>);
        }
        const onAgentChange = (agent) => this.setState({ selectedAgent: agent != null ? agent.Id : undefined });
        const onTypeChange = (type) => this.setState({ selectedType: type != null ? type.Id : undefined });

        return (
            <Grid fluid={true} >
                <Panel>
                    <Panel.Heading>Фильтр</Panel.Heading>
                    <Panel.Body>
                        <form className='form-horizontal'>
                            <div className="row" style={{ paddingBottom: "10px", paddingRight: "15px", paddingLeft: "15px" }}>
                                <div className="col-md-3">
                                    <Field name='departmentType' component={UnstiledDropdownListField} data={this.props.dcTypes}
                                        valueField='Id'
                                        textField='Name'
                                        label='Тип точки приема'
                                        customOnChange={onTypeChange}
                                        valueComponent={renderSelectedDepartmentType} />
                                </div>
                                <div className="col-md-3">
                                    <Field name='department' component={UnstiledDropdownListField} data={this.departmentFilter(departments, this.props.values)}
                                        valueField='Id'
                                        textField='FullName'
                                        label='Название точки приема'
                                        valueComponent={renderSelectedDepartment} />
                                </div>
                                <div className="col-md-3">
                                    <Field name='agent' component={UnstiledDropdownListField} data={agents}
                                        valueField='Id'
                                        textField='Name'
                                        label='Агент'
                                        customOnChange={onAgentChange}
                                        valueComponent={renderSelectedAgent} />
                                </div>
                            </div>
                        </form>
                    </Panel.Body>
                </Panel>
            </Grid>)
    }
}

function mapToProps(state, props, filterName, dcTypes) {
    const departments = state.application.get('settings')[depType];
    const agents = state.application.get('settings')[agentType];
    const values = getFormValues(filterName)(state);

    return { departments, agents, values, dcTypes };
}

export const filterNames = {
    onFactory: 'onFactoryFilter',
    onIntermediatePoint: 'onIntermediatePointFilter'
};

export const OnFactoryFilter = reduxForm({
    form: filterNames.onFactory
})(
    connect((state, props) => mapToProps(state, props, filterNames.onFactory, factories), { getSettings })(DcDepartmentsFilter)
);


export const OnIntermediatePointFilter = reduxForm({
    form: filterNames.onIntermediatePoint
})(
    connect((state, props) => mapToProps(state, props, filterNames.onIntermediatePoint, acceptPoints), { getSettings })(DcDepartmentsFilter)
);


// WEBPACK FOOTER //
// ./src/components/orders/filters/DcDepartmentsFilters.jsx